import { AutogenModelAvailableLoads, AutogenRowAvailableLoads } from "./autogen/AutogenModelAvailableLoads";

export class ModelAvailableLoads extends AutogenModelAvailableLoads<RowAvailableLoads> {
	constructor() {
		super(RowAvailableLoads);
	}
}

export class RowAvailableLoads extends AutogenRowAvailableLoads {
}